import { initialPoliciesState, type SharingPoliciesState } from './slices/policies/initial-state';
import { initialProfilesState, type SharingProfilesState } from './slices/profiles/initial-state';
import { initialUserManagementState, type SharingUserManagementState } from './slices/user-management/initial-state';
import { initialWizardUiState, type SharingWizardUiState } from './slices/wizard-ui/initial-state';

export type SharingState = SharingProfilesState & SharingPoliciesState & SharingUserManagementState & SharingWizardUiState;

export const initialState: SharingState = {
  ...initialProfilesState,
  ...initialPoliciesState,
  ...initialUserManagementState,
  ...initialWizardUiState,
};
